import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useWorkStyles } from './WorkSection.styles';
import WorkVisual from './WorkVisual';
import { fadeUp, stagger, viewportOnce } from '../../../../styles/animations';

const projects = [
    {
        index: '01',
        name: 'Financial Platform Transformation',
        tag: 'Digital strategy · Software engineering',
        gradient: 'linear-gradient(135deg, #1F2937 0%, #111827 100%)',
    },
    {
        index: '02',
        name: 'Digital Customer Experience',
        tag: 'Digital strategy · Product design',
        gradient: 'linear-gradient(135deg, #232A3D 0%, #111827 100%)',
    },
    {
        index: '03',
        name: 'Cloud Infrastructure',
        tag: 'Cloud & infrastructure',
        gradient: 'linear-gradient(135deg, #1B2230 0%, #111827 100%)',
    },
];

const WorkSection = () => {
    const { classes } = useWorkStyles();

    return (
        <Box component="section" id="work" className={classes.section}>
            <Box className={classes.inner}>
                <Box className={classes.header}>
                    <Box>
                        <Typography variant="overline" className={classes.eyebrow}>Selected work</Typography>
                        <Typography variant="h2">Case studies</Typography>
                    </Box>
                    <Typography variant="body2" className={classes.disclaimer}>
                        Concept case studies — illustrative work created for this
                        portfolio project, not real client engagements.
                    </Typography>
                </Box>

                <motion.div
                    className={classes.grid}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    variants={stagger(0.1)}
                >
                    {projects.map((p, i) => (
                        <motion.div
                            key={p.name}
                            variants={fadeUp}
                            className={classes.card}
                            whileHover={{ scale: 1.01 }}
                            transition={{ duration: 0.3 }}
                        >
                            <Box className={classes.cardOverlay} sx={{ background: p.gradient }} />
                            <Box className={classes.cardVisual}>
                                <WorkVisual variant={i} />
                            </Box>
                            <Box className={classes.cardScrim} />
                            <Box className={classes.cardBadge}>
                                <Typography variant="overline">Concept case study</Typography>
                            </Box>
                            <Box className={classes.cardContent}>
                                <Box>
                                    <Typography variant="overline" sx={{ color: 'primary.main' }}>{p.index}</Typography>
                                    <Typography variant="h4">{p.name}</Typography>
                                    <Typography variant="body2" className={classes.cardMeta}>{p.tag}</Typography>
                                </Box>
                            </Box>
                        </motion.div>
                    ))}
                </motion.div>
            </Box>
        </Box>
    );
};

export default WorkSection;
